<template>
    <div class="bg_white">
        <van-nav-bar
        title="我的培训"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        >
        <template #right>
            <van-icon name="wap-home-o" size="20"/>
        </template>
        </van-nav-bar>

        <van-cell-group inset  v-for="item in trainList" :key="item.train.id" :title="'考试期数:'+item.train.periods">
          <van-cell title="单位类型" :value="getWorkType(item.train.trainWorkType)" />
          <van-cell title="申领类型" :value="getApplyType(item.train.type)" />
          <van-cell title="资格类型" :value="getQulType(item.train.trainQualification)" />
          <van-cell title="培训地点" :value="item.train.trainAddress" />
          <van-cell title="考试地点" :value="item.train.examAddress" />
          <van-cell title="考试时间" :value="item.train.examTime" />
          <van-cell title="培训状态" :value="getTrainStatus(item.trainStudent.status)" />
          <div style="display: flex;justify-content: space-around;padding: 5px;">
             <van-button size="small" type="primary" @click="preTestStudy(item)">生成学时证明</van-button>
          </div>
          
        </van-cell-group>

        <div v-show="openStudyProve">
          <div class="studyTime" id="pdfDom">
          <div class="title">培训学时证明</div>
          <div class="content1">
            <p> {{trainData.trainStudent.studentName}}同志于{{timeDuration}}
              完成线上学时要求，特发此证，以此证明。</p>
            <p>培训内容：合计{{workCourseInfo.onlineTime}}学时</p>
            <div class="studyContent" v-html="htmlContent">

            </div>
          </div>
          <div class="userinfo">
            <li><label>姓名：</label><span>{{trainData.trainStudent.studentName}}</span></li>
            <li><label>性别：</label><span>{{trainData.trainStudent.sex==1?'男':'女'}}</span></li>
            <li><label>身份证号：</label><span>{{trainData.trainStudent.idCardNo}}</span></li>
            <li><label>培训科目：</label><span>
              {{ getSysWorkType(trainData.trainStudent.applyWorkType) }}
            </span></li>
          </div>
          <div class="face_img">
            <img v-if="studentPhoto.studentPhoto != '' && studentPhoto.studentPhoto != null" :src="'http://api.fzsyjxh.com/api/v1/getImage?name='+studentPhoto.studentPhoto" alt="" >
          </div>
          <div class="foot-info">
            <div>
            <!--  证书编号：{{ fileDetail.fileNo }}-->
            </div>
            <div>
<!--              发证时间：{{ parseTime(fileDetail.createTime, '{y}年{m}月{d}日') }}-->
            </div>
          </div>
          <div class="seal">

          </div>
        </div>
        </div>
    </div>
</template>

<script>
import {getUserTrainList,getDictData,getPhoto} from '../../api/custom'
import {getTimesDurantion,listWorkinfo,testStudyInfo} from '../../api/course'

export default {
  data() {
    return {
      trainStatusList:[],
      applyTypeList: [],
      workTypeList: [],
      sysWorkTypeList:[],//培训类别
      quaList: [],
      trainList:[],
      studentPhoto:{},
      htmlContent:"",
      trainData:{
        trainStudent:{
          studentName: null,applyWorkType: null,applyQualification: null,applyType: null,sex:null
        },
        trainInfo:{trainAddress:null},
        studentInfo:{company:null},
      },
      expoertStudy:false,//是否展示学时证明
      fileDetail:{},
      workCourseInfo:{},
      timeDuration:{},
      fs1Time:"",
      fs2Time:"",
      openStudyProve:false

    }

   },
   created(){
     //申领资格
     getDictData("sys_apply_type").then(res => {
      this.applyTypeList = res.data.list
    })

    //单位类型
    getDictData("exam_work_type").then(res => {
      this.workTypeList = res.data.list
    })
    //资格类型
    getDictData("sys_qulification_type").then(res => {
      this.quaList = res.data.list
    })

    //培训类型
    getDictData("sys_work_type").then(res => {
      this.sysWorkTypeList = res.data.list
    })

     //培训状态
     getDictData("train_status").then(res => {
      this.trainStatusList = res.data.list
    })
    getUserTrainList().then(res=>{
      this.trainList=res.data.list
    })
   },
   methods: {
    getTrainStatus(val){
      let result = ""
      this.trainStatusList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/home")
    },
    getQulType(val) {
      let result = ""
      this.quaList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getApplyType(val) {
      let result = ""
      this.applyTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getWorkType(val) {
      let result = ""
      this.workTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getSysWorkType(val) {
      let result = ""
      this.sysWorkTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },

    //检测是否完成必修
    preTestStudy(item){
      console.log(item)
      testStudyInfo(item.trainStudent.id).then(res=>{
        console.log(res)
        if (res.data.result){
          console.log(res.data)
          this.exportStudyTime(item)
        }else {
          console.log("失败")
          this.$dialog.alert({
          message: "未完成必修课程",
          theme: 'round-button',
          confirmButtonText: '确定'
        })
          
        }
      })
    },
    htmlDecode(text) {
      // 创建一个元素容器
      var tempDiv = document.createElement('div');
      // 把解码字符串赋值给元素innerHTML
      tempDiv.innerHTML = text;
      // 最后返回这个元素的innerText(ie支持)或者textContent(火狐、谷歌等支持)
      var output = tempDiv.innerText || tempDiv.textContent;
      tempDiv = null;
      return output;
    },

    //生成学时证明
    exportStudyTime(item){
      console.log("生成学时证明")
      this.studentPhoto=null
      getPhoto().then(res=>{
        this.studentPhoto=res.data.result
      })
      console.log(item.trainStudent)
      this.trainData.trainStudent=item.trainStudent
      this.trainData.trainStudent.sex=item.sex
      this.trainData.trainStudent.idCardNo=item.idCardNo
      // this.checkFile();
      listWorkinfo(item.trainStudent.id).then(resp=>{
        this.workCourseInfo=resp.data.result
        this.htmlContent=this.htmlDecode(resp.data.result.contents)
      })
      getTimesDurantion(item.trainStudent.id).then(res=>{
        console.log(res)
        this.timeDuration=res.data.result
      })
      this.openStudyProve=true

      this.$dialog.alert({
              message: "确定下载学时证明？",
              theme: 'round-button',
              confirmButtonText: '确定',

            }).then(()=>{
              this.getPdf('#pdfDom')
            })
      

    },


    

    
  }

};
</script>

<style lang="less">
.seal{
  width: 100px;
  height: 100px;
  position: absolute;
  right: 80px;
  bottom: 40px;
  background: url(../../asset/images/redmiwork.png) no-repeat ;
  background-size: contain;
}
.studyTime{
  width: 512px;
  height: 772px;
  /*height: 600px;*/
  background: url(../../asset/images/bag1.jpg) no-repeat ;
  background-size: contain;
  padding: 55px 55px 20px;
  position: relative;
  box-sizing: border-box;

}
.studyTime .face_img{
  position: absolute;
  right: 56px;
  bottom: 179px;
  /*width: 120px;*/
  font-size: 12px;
}
.studyTime .face_img img{
  height: 120px;
}
.studyTime .face_img p{
  width: 100%;
  text-align: center;
  line-height: 18px;
  color: #000000;
  font-size: 12px;
  font-weight: bold;
}
.studyTime .foot-info{
  position: absolute;
  bottom: 48px;
  display: flex;
  justify-content: space-between;
  width: 80%;
  font-size: 12px;
  font-weight: bold;
  color: #000000;
}
.studyTime .title{
  font-size: 18px;
  color: #1e1e1e;
  font-weight: bold;
  text-align: center;

}
.studyTime .content1{
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  position: static;
  line-height: 24px;
}
.studyTime li{
  list-style: none;
}
.studyContent{
  font-weight: normal;
  display: flex;
  /*justify-content: space-between;*/
  flex-direction: column;

}
.studyContent li{
  list-style: none;
  width: 100%;
  display: flex;
  line-height: 25px;
  border: 1px solid #000;
}
.studyContent li span:first-child{
  width: 8%;
  border-right: 1px solid #000;
  text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.studyContent li span:nth-child(2){
  width: 77%;
  border-right: 1px solid #000;
  padding-left: 4px;
  text-align: left;
}
.studyContent li span:last-child{
  width: 20%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}


.studyContent li:nth-child(n+2){
  border-top: none;
}
.studyTime .userinfo{
  position: absolute;
  left: 63px;
  bottom: 179px;
  color: #000000;
}
.studyTime .userinfo li{
  font-weight: bold;
  color: #000000;
  line-height: 28px;
  font-size: 14px;
}

.fileImage {
  width: 400px;
  margin: 8px auto;
  position: relative;
/*// padding: 10px;*/
/*// height: 572px;*/
/*// border: 1px solid #ebedf0;*/
  border-radius: 6px;
  /*background: url(../../asset/images/filebg2.png) no-repeat;*/
  background-size: contain;
  height: 255px;
  overflow: hidden;
}
.fileImage span{
  font-size: 0.8em;
}
.fileImage .filePic{
  position: absolute;
  margin-top: 30px;
  margin-left: 26px;
  width: 90px;
  height: 115px;

}
.fileImage .fileNo{
  margin-left: 134px;
  position: absolute;
  margin-top: 39px;

}
.fileImage .name{
  margin-left: 134px;
  position: absolute;
  margin-top: 72px;
}
.fileImage .type1{
  margin-left: 252px;
  position: absolute;
  margin-top: 72px;
}

.fileImage .sex{
  margin-left: 134px;
  position: absolute;
  margin-top: 122px;
}
.fileImage .type2{
  margin-left: 252px;
  position: absolute;
  margin-top: 122px;
}
.fileImage  .fs1{
  margin-left: 28px;
  position: absolute;
  margin-top: 214px;
  font-size: 10px;
}
.fileImage  .fs2{
  margin-left: 147px;
  position: absolute;
  margin-top: 214px;
  font-size: 10px;
}
.fileImage .start{
  margin-left: 24px;
  position: absolute;
  margin-top: 181px;
  font-size: 10px;
}
.fileImage .duration{
  margin-left: 140px;
  position: absolute;
  margin-top: 181px;
  font-size: 10px;
}
.fileImage .manage{margin-left: 24px;
  position: absolute;
  margin-top: 211px;
  font-size: 10px;}
.fileImage div {
  color: #333;
  font-size: 12px;
}

.fileImage span {
  color: #000;
/*// font-size: 14px;*/
}


</style>

